import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { EyeIcon } from "assets";
import { usePdfNavigation } from "components";

export const FieldPageButton: React.FC<{
  pageNumber: number;
  bboxKey?: string;
}> = ({ pageNumber, bboxKey }) => {
  const { navigateToPage } = usePdfNavigation();
  return (
    <Tooltip title="View extracted value in PDF" placement="top">
      <IconButton
        style={{ paddingBottom: "10px" }}
        size="small"
        onClick={() => navigateToPage(pageNumber + 1, bboxKey)}
      >
        <EyeIcon />
      </IconButton>
    </Tooltip>
  );
};
